export default {
  general: {
    settings: "Settings",
    show_time: "Show Time Display",
    show_seconds: "Show Seconds",
    show_search: "Show Search Bar",
    show_wallpaper: "Show Skip Wallpaper Button",
    show_bookmark: "Show Bookmark Button",
    show_weather: "Show Weather Display",
    show_top_sites: "Show Frequently Visited Sites",
    auto_change_background: "Automatically Change Background",
    auto_change_every: "Change every",
    days: "days",
    hours: "hours",
    minutes: "minutes",
    interval_required: "Days, hours, and minutes cannot all be 0",
    sync_enabled: "Enable Todo Cloud Sync",
    show_ai_chat: "Show AI Chat Button",
  },
  profile: {
    title: "Profile",
    logout: "Logout",
    sign_in: "Sign In",
    sign_in_desc: "Please sign in to unlock the full experience",
    avatar_updated: "Avatar updated successfully",
    nickname_updated: "Nickname updated successfully",
    avatar_size: "Avatar file size must not exceed 500KB",
    login_required: "You must be logged in to update your avatar",
    login_success: "Login successful",
    edit_avatar: "Edit Avatar",
    edit_nickname: "Edit Nickname"
  },
  subscription: {
    title: "Subscription",
    check: "Check my subscription",
    upgrade: "Upgrade subscription",
    subscribe: "Subscribe to Tabby",
    expired_on: "Expired on: {0}",
    expires_on: "Expires on: {0}",
    plans: {
      premium: "Unlock all of Tabby — unlimited wallpapers, custom backgrounds, and exclusive collections.",
      pro: "Upgrade to unlock unlimited wallpaper skips, custom backgrounds, and exclusive collections.",
      free: "Subscribe to unlock unlimited wallpaper skips, custom backgrounds, and exclusive collections."
    }
  },
  wallpaper: {
    title: "Wallpaper",
    upload: "Upload custom background",
    upgrade_required: "Upgrade to Pro/Premium plan to unlock custom background feature",
    images: "Images",
    hues: "Hues",
    anims: "Anims",
    diy: "DIY",
    get_new: "Get New",
    upload_background: "Upload Background",
    add: "Add",
    remote_url: "Remote Image URL",
    size_tip: "Smaller background files load tabs faster. Most browsers have a 1.5MB file size limit. Remote URLs have no restrictions.",
    please_login: "Please login first",
    click_to_upload: "Click to upload",
    video_gif_image: "video, GIF or image",
    background: "background",
    or_enter_remote_background_url: "Or enter remote background URL",
    remote_url_placeholder: "https://example.com/image.jpg",
    custom_background_removed: "Custom background removed",
    failed_to_load_background: "Failed to load background",
    using_default: "Using default background instead",
    insufficient_storage: "Insufficient storage",
    upload_failed: "Upload failed",
    success: "Success",
    remote_background_added: "Remote background added",
    detecting_media_type: "Detecting media type...",
    invalid_media_type: "Unrecognized media type",
    video_load_failed: "Video cannot be loaded, please check if the URL is correct"
  },
  rewards: {
    title: "Rewards",
    invite_friends: "Invite Friends",
    get_access: "Invite friends to unlock discounts on Pro",
    total_invites: "Total Invites",
    your_discount: "Your discount",
    no_pro_yet: "None yet",
    copy_link: "Copy Invite Link",
    copied: "Invite link copied!",
    copy_failed: "Failed to copy link",
    invite_description: "Invite a friend to sign up with your link",
    receive_credits: "You get: 1 invite → 5% off, 2 → 8% off, 3 → 15% off, 4+ → 20% off · Each friend gets 5% off"
  },
  paywall: {
    title: "Tabby Pro",
    pro_active: "PRO ACTIVE",
    expires: "expires",
    free_plan: "FREE PLAN",
    tagline: "Unlock full chat quotas, cloud todo sync, and all wallpaper features in this extension.",
    monthly: "MONTHLY",
    yearly: "YEARLY",
    month_period: "/month",
    year_period: "/year",
    billed_monthly: "Billed monthly · cancel anytime",
    billed_yearly: "Billed yearly",
    checkout_usd: "Checkout",
    save_yearly: "Save 17% vs monthly",
    best_value: "BEST VALUE",
    referral_price: "Referral price",
    save: "save",
    subscribe_now: "Subscribe Now",
    current_plan: "Current Plan",
    processing: "Processing",
    waiting_title: "Waiting for Payment",
    waiting_desc: "Please complete the payment in the newly opened window.",
    payment_completed: "Payment Completed",
    having_issues: "Having Issues",
    invite_save: "Invite friends and save on Pro",
    sign_in_first: "Please sign in first",
    checkout_failed: "Failed to create checkout session",
    payment_failed: "Payment failed",
    payment_wrong: "Oh, Something went wrong! Please try again.",
    success_msg: "Congratulations! Payment completed successfully",
    not_paid_msg: "Payment has not been completed yet. Please complete the payment in the checkout window or try again.",
    verify_failed: "Failed to verify payment status. Please try again or contact support.",
    contact_email: "Please contact email: hi@tabbyio.com"
  },
  about: {
    title: "About",
    version: "Version: 1.3.11",
    contact: "Contact us:",
    privacy_policy: "Privacy Policy",
    terms_of_service: "Terms of Service"
  },
  tabs: {
    general: "Preferences",
    profile: "Profile",
    wallpaper: "Wallpaper",
    rewards: "Rewards",
    about: "About"
  },
  language: {
    title: "Language",
    en: "English",
    zh: "中文",
    de: "Deutsch",
    fr: "Français",
    pt: "Português",
    ru: "Русский",
    bn: "বাংলা",
    ja: "日本語",
    es: "Español"
  },
  buttons: {
    bookmark: "Bookmarks",
    next_background: "Next Background",
    ai_chat: "AI Chat",
    search_placeholder: "Search or press Ctrl + Enter for AI chat...",
    attach: "Attach file",
    close: "Close"
  },
  top_sites: {
    title: "Frequently Visited",
    error: "Could not load frequently visited sites",
    empty: "No frequently visited sites found",
    remove: "Remove site",
    pin: "Pin",
    unpin: "Unpin",
    delete: "Delete"
  },
  greetings: {
    morning: "Good morning",
    afternoon: "Good afternoon", 
    evening: "Good evening",
    morning_message: "A new day begins, how can I help you?",
    afternoon_message: "Afternoon time, any questions you'd like to ask?",
    evening_message: "Evening time, let me chat with you!"
  },
  intro: {
    your_portal: "Your portal",
    for: "for",
    productivity: "productivity.",
    inspiration: "inspiration.",
    photography: "photography.",
    description: "Where every new tab becomes a gateway",
    description_continued: "to elegance, productivity, and beyond.",
    add_to_chrome: "Add to Chrome",
    add_to_edge: "Add to Edge",
    add_to_firefox: "Add to Firefox",
    add_to_browser: "Add to Browser",
    free: "Free",
    try_now: "Try Now",
    screenshot: "Screenshot"
  }
}

